export default "__VITE_ASSET__DzmCGSGB__$_?react__"